import React, { useEffect, useState } from 'react';
import AdminLayout from '@/components/admin/AdminLayout';
import { API } from '@/App';
import axios from 'axios';
import { Briefcase, FolderKanban, FileText, Users, Mail } from 'lucide-react';

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API}/stats`);
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const statCards = [
    { icon: Briefcase, label: 'Hizmetler', value: stats?.services || 0, color: 'from-blue-500 to-blue-600' },
    { icon: FolderKanban, label: 'Projeler', value: stats?.projects || 0, color: 'from-green-500 to-green-600' },
    { icon: FileText, label: 'Blog Yazıları', value: stats?.blog_posts || 0, color: 'from-purple-500 to-purple-600' },
    { icon: Users, label: 'Ekip Üyeleri', value: stats?.team_members || 0, color: 'from-orange-500 to-orange-600' },
    { icon: Mail, label: 'Okunmamış Mesajlar', value: stats?.unread_messages || 0, color: 'from-red-500 to-red-600' },
  ];

  return (
    <AdminLayout>
      <div data-testid="admin-dashboard">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Dashboard</h1>
          <p className="text-white/60">Hoş geldiniz! İşte sitenizin özeti.</p>
        </div>

        {loading ? (
          <div className="text-white/60">Yükleniyor...</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
            {statCards.map((stat, index) => (
              <div
                key={index}
                data-testid={`stat-card-${index}`}
                className="glass p-6 rounded-2xl card-hover"
              >
                <div className={`w-12 h-12 rounded-lg bg-gradient-to-br ${stat.color} flex items-center justify-center mb-4`}>
                  <stat.icon className="w-6 h-6 text-white" />
                </div>
                <div className="text-3xl font-bold mb-1">{stat.value}</div>
                <div className="text-sm text-white/60">{stat.label}</div>
              </div>
            ))}
          </div>
        )}

        <div className="mt-8 glass p-6 rounded-2xl">
          <h2 className="text-xl font-semibold mb-4">Hızlı Eylemler</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <button
              onClick={() => window.location.href = '/admin/hizmetler'}
              className="p-4 bg-white/5 rounded-lg hover:bg-white/10 transition-colors text-left"
              data-testid="quick-action-services"
            >
              <Briefcase className="w-6 h-6 text-[#FF6B35] mb-2" />
              <div className="font-medium">Yeni Hizmet Ekle</div>
            </button>
            <button
              onClick={() => window.location.href = '/admin/projeler'}
              className="p-4 bg-white/5 rounded-lg hover:bg-white/10 transition-colors text-left"
              data-testid="quick-action-projects"
            >
              <FolderKanban className="w-6 h-6 text-[#FF6B35] mb-2" />
              <div className="font-medium">Yeni Proje Ekle</div>
            </button>
            <button
              onClick={() => window.location.href = '/admin/blog'}
              className="p-4 bg-white/5 rounded-lg hover:bg-white/10 transition-colors text-left"
              data-testid="quick-action-blog"
            >
              <FileText className="w-6 h-6 text-[#FF6B35] mb-2" />
              <div className="font-medium">Yeni Blog Yazısı</div>
            </button>
            <button
              onClick={() => window.location.href = '/admin/mesajlar'}
              className="p-4 bg-white/5 rounded-lg hover:bg-white/10 transition-colors text-left"
              data-testid="quick-action-messages"
            >
              <Mail className="w-6 h-6 text-[#FF6B35] mb-2" />
              <div className="font-medium">Mesajları Görüntüle</div>
            </button>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;